import "./Autocomplete.scss";

import { TextField as MUITextField } from "@material-ui/core";
import { AutocompleteProps as MUIAutocompleteProps, createFilterOptions, default as MUIAutocomplete } from "@material-ui/lab/Autocomplete";
import React from "react";

export interface AutocompleteProps extends MUIAutocompleteProps<any, undefined, undefined, undefined> {
  error: any;
  getIcon?: (code: string) => any;
  id: string;
  label: React.ReactNode;
  onChange: (value: any) => void;
  showIcon?: boolean;
}

export const Autocomplete = (props: AutocompleteProps) => {
  // Props
  const {
    className,
    disabled,
    error,
    getIcon,
    onChange,
    options,
    label,
    placeholder,
    showIcon,
    value,
  } = props;

  // Options
  const baseFilter = createFilterOptions({ matchFrom: "start" });

  const getOptionLabel = (option: any) => {
    return option ? option.label : "";
  };

  const adaptStateForFilter = (state: any) => {
    return {
      ...state,
      getOptionLabel,
    };
  };

  const filterOptions = (
    options: any, state: any
  ) =>
    baseFilter(
      options,
      adaptStateForFilter(state)
    );

  const getOptionValueLabel = (value: any) => {
    let selectedOption = options.find((option: any) => option.code === value);
    return selectedOption && selectedOption.label
      ? selectedOption.label
      : "";
  }

  const getOptionSelected = (
    option: any, value: any
  ) => {
    return option.code === value;
  }

  const renderOption = (option: any) =>
    <React.Fragment>
      {getIcon ?
        <span style={{ marginRight: 8 }}>{getIcon(option.code)}</span>
        :
        <></>
      }
      {option.label}
    </React.Fragment>

  const autocompleteIconClassName =
    "autocomplete-icon" + (disabled ? "--disabled" : "");

  const autocompleteProps = { ...props };
  delete autocompleteProps.getIcon;
  delete autocompleteProps.showIcon;
  delete autocompleteProps.error;

  return (
    <MUIAutocomplete
      {...autocompleteProps}
      filterOptions={filterOptions}
      openOnFocus={false}
      getOptionSelected={getOptionSelected}
      getOptionLabel={getOptionValueLabel}
      onChange={(
        _: any, value: any
      ) => {
        onChange(value);
      }}
      renderOption={renderOption}
      renderInput={(params: any) =>
        <div className={className + (showIcon ? " autocomplete-wrapper-with-icons" : "")}>
          <span className="autocomplete-icon-container">
            <span className={autocompleteIconClassName}>
              {showIcon && getIcon ? getIcon(value) : null}
            </span>
          </span>
          <MUITextField
            {...params}
            disabled={disabled}
            variant="outlined"
            required={!disabled}
            label={label}
            placeholder={placeholder}
            error={error}
            helperText={error}
            autoComplete="new-password"
          />
        </div>
      }
    />
  );
};

Autocomplete.defaultProps = {
  onChange: (value: string) => value,
  renderOption: (option: any) => option.label,
  renderInput: (params: any) => <MUITextField {...params} />,
}
